import { createApp } from 'vue'
import { createPinia } from 'pinia'
// ALENS-128: Element Plus 按需引入 —— 组件本体由 unplugin-vue-components 的
// ElementPlusResolver 按模板用到的标签解析; 这里只补两个**程序化** API 的样式
// (ElMessage / ElMessageBox 是直接 import 的, 不走模板解析, resolver 不会带样式)。
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/message-box/style/css'
import App from './App.vue'
import router from './router'
import './assets/main.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')
